import React from 'react';
import Section from '../../../shared/Section/Section';
import Statistic from '../../../shared/Statistic/Statistic';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Career } from '../../BenefitsStrip/ui/images/career';
import AlumniCompanies from '../../AlumniCompanies/AlumniCompanies';
import styles from './styles';

export default function PrecourseAbout({
  title,
  statistic,
  description,
  images,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const image = getImage(images['about/precourse-about']);
  const CareerDescription = (
    <Box sx={styles.careerDescription}>
      <Career />
      <Typography variant="desktopP1" color={'kit.text.main'} mt={1.5}>
        {description}
      </Typography>
    </Box>
  );
  return (
    <Section title={title} theme="light" withoutBg>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={styles.statBox}>
            <Statistic statistic={statistic} noWrapLink />
          </Box>
          {!isSm && CareerDescription}
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={styles.imageBox}>
            <GatsbyImage image={image} alt="about" />
          </Box>
          {isSm && CareerDescription}
        </Grid>
      </Grid>
      <Typography
        variant="desktopH4"
        color={'kit.text.h'}
        sx={styles.companiesTitle}
      >
        Выпускники работают в крупных компаниях
      </Typography>
      <AlumniCompanies noBottomText />
    </Section>
  );
}
